export default "__VITE_ASSET__3b718607__"